import React, { useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import ApiClients from './ApiClients';
import AsroSyncConnect from './AsroSyncConnect';
import OAuthScopes from './OAuthScopes';
import { harmonateTokens as ht } from '../../../theme/harmonateTokens';
import {
  harmonatePageSx,
  harmonatePageTitleSx,
  harmonateCardSx,
  harmonateTabsSx,
} from '../../../theme/harmonateStyles';

/**
 * Configurations → External Integration
 * Credentials: Conductor API clients + Connect to AsroSync
 * Scopes: global OAuth scope catalog + endpoint rules
 */
const ExternalIntegrationHub = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ ...harmonatePageSx, minHeight: '100vh' }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={harmonatePageTitleSx}>
          External Integration
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5, maxWidth: 820, color: ht.secondaryTab }}>
          Create Conductor credentials for partners (e.g. AsroSync), connect this tenant to AsroSync,
          or manage the global OAuth scope catalog.
        </Typography>
      </Box>

      <Paper elevation={0} sx={{ ...harmonateCardSx, mb: 2.5, flexShrink: 0 }}>
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          sx={harmonateTabsSx}
        >
          <Tab label="Credentials" />
          <Tab label="Scopes" />
        </Tabs>
      </Paper>

      {tab === 0 && (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', lg: 'minmax(0, 1.45fr) minmax(300px, 0.8fr)' },
            gap: 2.5,
            alignItems: 'stretch',
            minHeight: { xs: 'auto', lg: 'calc(100vh - 210px)' },
          }}
        >
          <Box
            sx={{
              ...harmonateCardSx,
              minHeight: { xs: 420, lg: 0 },
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            <ApiClients />
          </Box>
          <Box
            sx={{
              ...harmonateCardSx,
              minHeight: { xs: 280, lg: 0 },
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <AsroSyncConnect />
          </Box>
        </Box>
      )}

      {tab === 1 && (
        <Box
          sx={{
            ...harmonateCardSx,
            height: { xs: 'auto', lg: 'calc(100vh - 210px)' },
            minHeight: { xs: 480, lg: 'calc(100vh - 210px)' },
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <OAuthScopes />
        </Box>
      )}
    </Box>
  );
};

export default ExternalIntegrationHub;
